export default function Art ({ url }) {
  return (
    <div className='flex mb-2'>
      <div className='flex-1' />
      <div className='flex-5'>
        <img src={url} width='1024' height='1024' />
      </div>
      <div className='flex-1' />
    </div>
  )
}
